import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import './hover.css';
import * as dom from '../../dom.js';
import { Disposable } from '../../../common/lifecycle.js';
import { DomScrollableElement } from '../scrollbar/scrollableElement.js';
var $ = dom.$;
export var HoverWidget = /*#__PURE__*/function (_Disposable) {
  _inherits(HoverWidget, _Disposable);

  var _super = _createSuper(HoverWidget);

  function HoverWidget() {
    var _this;

    _classCallCheck(this, HoverWidget);

    _this = _super.call(this);
    _this.containerDomNode = document.createElement('div');
    _this.containerDomNode.className = 'monaco-hover';
    _this.containerDomNode.tabIndex = 0;

    _this.containerDomNode.setAttribute('role', 'tooltip');

    _this.contentsDomNode = document.createElement('div');
    _this.contentsDomNode.className = 'monaco-hover-content';
    _this._scrollbar = _this._register(new DomScrollableElement(_this.contentsDomNode, {}));

    _this.containerDomNode.appendChild(_this._scrollbar.getDomNode());

    return _this;
  }

  _createClass(HoverWidget, [{
    key: "onContentsChanged",
    value: function onContentsChanged() {
      this._scrollbar.scanDomNode();
    }
  }]);

  return HoverWidget;
}(Disposable);
export function renderHoverAction(parent, actionOptions, keybindingLabel) {
  var actionContainer = dom.append(parent, $('div.action-container'));
  var action = dom.append(actionContainer, $('a.action'));
  action.setAttribute('href', '#');
  action.setAttribute('role', 'button');

  if (actionOptions.iconClass) {
    dom.append(action, $("span.icon.".concat(actionOptions.iconClass)));
  }

  var label = dom.append(action, $('span'));
  label.textContent = keybindingLabel ? "".concat(actionOptions.label, " (").concat(keybindingLabel, ")") : actionOptions.label;
  return dom.addDisposableListener(actionContainer, dom.EventType.CLICK, function (e) {
    e.stopPropagation();
    e.preventDefault();
    actionOptions.run(actionContainer);
  });
}